import React, { FC } from 'react';

import { AuthPageWrapper } from '../AuthPageLayout';
import { ExpiredInvitationLink } from 'features/feature-finish-registration/ExpiredInvitationLink';

/**
 * A wrapper component that renders a registration expired code page.
 */
export const RegistrationExpiredCode: FC = () => {
  return (
    <AuthPageWrapper>
      <ExpiredInvitationLink />
    </AuthPageWrapper>
  );
};
